<ng-container *ngIf="data$ | async as data; else noMazCard">
  <div *ngFor="let mazcard of data">
    <div @list class="property-title">
      {{ 'properties.maz.title' | translate }}
      {{ mazcard.mazNr }}
    </div>

    <mat-card
      @items
      *ngFor="let file of mazcard.files; trackBy: trackById"
      class="p-2"
      [ngClass]="{ selected: isSelected(mazcard.mazNr, file) | async }"
      (click)="select(mazcard.mazNr, file)"
    >
      <span *ngIf="file !== routeNames.newFileID; else new"> {{ file }}</span>
      <ng-template #new>
        <span> {{ 'properties.maz.newFile' | translate }}</span>
      </ng-template>
    </mat-card>

    <button
      mat-raised-button
      color="warn"
      *ngIf="mazcard.isDraftAvailable"
      (click)="select(mazcard.mazNr, routeNames.draftFileID)"
    >
      <div class="d-flex align-items-center">
        <span>{{ 'properties.button.draft' | translate }}</span>
        <mat-icon class="ms-auto">assignment</mat-icon>
      </div>
    </button>

    <button
      mat-raised-button
      color="accent"
      *ngIf="displayNew(mazcard.files)"
      (click)="select(mazcard.mazNr, routeNames.newFileID)"
      [disabled]="mazcard.isDraftAvailable"
    >
      <div
        class="d-flex align-items-center"
        matTooltip="{{ 'properties.button.disabled' | translate }}"
        [matTooltipDisabled]="!mazcard.isDraftAvailable"
      >
        <span>{{ 'properties.button.newFile' | translate }}</span>
        <mat-icon class="ms-auto">add</mat-icon>
      </div>
    </button>
  </div>
</ng-container>

<ng-template #noMazCard>
  <div class="d-flex justify-content-center align-items-center flex-column empty-search">
    <mat-icon class="large">insert_drive_file</mat-icon>
    <span>{{ 'properties.noMazCard' | translate }}</span>
  </div>
</ng-template>
